import { setListaFiltered, setRequestFilterData, setRequestFilterError, setRequestFilterLoading, setRequestFilterMessage } from "../Reducers/ClientsReducer"
import { RequestResponsePattern } from "../../../../../types/Request"
import { getApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."
import { ClienteType } from "../../Parametro/Types/ClienteType"
//import { FilterParams } from "../../Parametro/Types/ClienteType"
    
export default async function filter(dispatch: Function, values: any){
    try {
        dispatch(setRequestFilterLoading())
        const response: RequestResponsePattern<ClienteType[]> = await getApi({ endpoint: `${DOMAIN}/Pessoa`, params: `/?descricao=${values.descricao}&flagAtivo=${values.flagAtivo === 'null' ? '' : values.flagAtivo}&flagMedidor=${values.flagMedidor === 'null' ? '' : values.flagMedidor}` });
        
        if(response){
            dispatch(setRequestFilterData(response))
            if(!response.flagErro) dispatch(setListaFiltered(response.listaResultados.filter(item => item.nome.toLowerCase().includes(values.descricao.toLowerCase()))))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')

    } catch (error: any) {
        dispatch(setRequestFilterMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestFilterError())
    }
}